//#region import libraries
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Row, Col, Image, Alert } from 'react-bootstrap';
import { LoginPage } from '_molecules';
import { setLogoutAlert, selectLogoutAlert } from '_redux/slices/main-screen/modal'
import image from "_assets/images/PRM-Logo-PNG/white-text.png";
import { Colors } from '_styles';
//#endregion

const Register = () => {
  const dispatch = useDispatch();
  const showLogoutAlert = useSelector(selectLogoutAlert);

  return (
    <>
      <Container fluid={true}>
        <Row>
          <Col xs={3} className="vh-100 justify-content-md-center" style={{ backgroundColor: Colors.PRM_LIGHT_BLUE }}>
            <Container className="mt-5 d-flex justify-content-center">
              <Image src={image} height={50} />
            </Container>
          </Col>

          <Col className="vh-100 mt-5">
            {showLogoutAlert &&
              <Alert variant="info" onClose={() => dispatch(setLogoutAlert(false))} dismissible>
                <Alert.Heading>Your session has expired</Alert.Heading>
                <p>For security your session has timed out, log back in to access the portal.</p>
              </Alert>
            }
            <LoginPage />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Register;
